import { decimal } from 'vuelidate/lib/validators';

export default {
    decimal
};